<template>
  <v-form>
    <v-container class="mb-4">
      <v-subheader>
        <v-icon class="mr-2">mdi-domain</v-icon>
        Dados da empresa
      </v-subheader>
      <v-row>
        <v-col cols="12" sm="8">
          <v-text-field
            outlined
            hide-details
            label="Nome"
            class="required"
            maxlength="150"
            :error="$v.empresa.pessoa.nomeReceita.$error"
            @blur="$v.empresa.pessoa.nomeReceita.$touch()"
            v-model="empresa.pessoa.nomeReceita"
          />
        </v-col>
        <v-col cols="12" sm="4">
          <v-text-field
            outlined
            hide-details
            label="CNPJ"
            :disabled="true"
            class="required"
            v-mask="'##.###.###/####-##'"
            :error="$v.empresa.pessoa.cnpj.$error"
            @blur="$v.empresa.pessoa.cnpj.$touch()"
            v-model="empresa.pessoa.maskedCnpj"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="7">
          <v-text-field
            outlined
            hide-details
            maxlength="100"
            label="Nome fantasia"
            class="required"
            :error="$v.empresa.pessoa.nome.$error"
            @blur="$v.empresa.pessoa.nome.$touch()"
            v-model="empresa.pessoa.nome"
          />
        </v-col>
        <v-col cols="12" sm="5">
          <v-text-field
            outlined
            hide-details
            type="email"
            label="E-mail"
            class="required"
            maxlength="100"
            :error="$v.empresa.pessoa.email.$error"
            @blur="$v.empresa.pessoa.email.$touch()"
            v-model="empresa.pessoa.email"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="8">
          <v-text-field
            outlined
            hide-details
            label="Site"
            maxlength="100"
            v-model="empresa.site"
          />
        </v-col>
        <v-col cols="12" sm="4">
          <v-text-field
            outlined
            hide-details
            label="Telefone"
            v-mask="['(##) ####-####', '(##) #####-####']"
            v-model="empresa.pessoa.telefone"
          />
        </v-col>
      </v-row>
      <v-subheader>
        <v-icon class="mr-2">mdi-map-marker</v-icon>
        Endereço
      </v-subheader>
      <v-row>
        <v-col cols="12" sm="3">
          <v-text-field
            outlined
            hide-details
            label="CEP"
            v-mask="['#####-###']"
            class="required"
            :error="$v.empresa.endereco.cep.$error"
            @blur="$v.empresa.endereco.cep.$touch()"
            v-model="empresa.endereco.cep"
            @change="onChangeCep"
          />
        </v-col>
        <v-col cols="12" sm="6">
          <v-text-field
            outlined
            hide-details
            label="Logradouro"
            maxlength="100"
            class="required"
            :error="$v.empresa.endereco.rua.$error"
            @blur="$v.empresa.endereco.rua.$touch()"
            v-model="empresa.endereco.rua"
          />
        </v-col>
        <v-col cols="12" sm="3">
          <v-text-field
            outlined
            hide-details
            label="Número"
            maxlength="6"
            v-mask="['######']"
            v-model="empresa.endereco.numero"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="5">
          <v-text-field
            outlined
            hide-details
            label="Bairro"
            maxlength="60"
            class="required"
            :error="$v.empresa.endereco.bairro.$error"
            @blur="$v.empresa.endereco.bairro.$touch()"
            v-model="empresa.endereco.bairro"
          />
        </v-col>
        <v-col cols="12" sm="3">
          <px-autocomplete-uf outlined
                              hide-details
                              class="required"
                              :error="$v.empresa.endereco.estado.$error"
                              @blur="$v.empresa.endereco.estado.$touch()"
                              v-model="empresa.endereco.estado"
                              @change="onChangeUf"
          />
        </v-col>
        <v-col cols="12" sm="4">
          <px-autocomplete-municipio
            outlined
            hide-details
            class="required"
            :uf="empresa.endereco.estado"
            :disabled="!empresa.endereco.estado"
            :error="$v.empresa.endereco.municipio.$error"
            @blur="$v.empresa.endereco.municipio.$touch()"
            v-model="empresa.endereco.municipio"/>
        </v-col>
      </v-row>
    </v-container>
    <v-btn color="primary"
           class="mr-2"
           :disabled="$v.$invalid"
           @click="emitReady">
      Próximo
    </v-btn>
    <v-btn @click="emitBack">
      Voltar
    </v-btn>
  </v-form>
</template>

<script>
import CepService from '@/api/cep-service';
import { required, email } from 'vuelidate/lib/validators';

const CEP_LENGTH = 9;

export default {
  props: {
    empresa: {
      type: Object,
      required: true,
    },
  },
  methods: {
    emitReady() {
      this.$emit('ready');
    },
    emitBack() {
      this.$emit('back');
    },
    clearEndereco() {
      this.empresa.endereco.rua = '';
      this.empresa.endereco.bairro = '';
      this.empresa.endereco.estado = null;
      this.empresa.endereco.municipio = null;
    },
    handleEndereco(data) {
      if (!data || data.erro) {
        this.clearEndereco();
        return;
      }

      this.empresa.endereco.rua = data.rua;
      this.empresa.endereco.bairro = data.bairro;
      this.empresa.endereco.estado = data.estado;
      this.empresa.endereco.municipio = data.municipio;
    },
    getCepData(cep) {
      CepService.get(cep)
        .then(({ data }) => {
          this.handleEndereco(data);
        });
    },
    onChangeCep() {
      if (!this.empresa.endereco.cep || this.empresa.endereco.cep.length !== CEP_LENGTH) {
        return;
      }
      const cep = this.empresa.endereco.cep.match(/\d+/g).join('');
      this.getCepData(cep);
    },
    onChangeUf() {
      this.empresa.endereco.municipio = null;
    },
  },
  validations: {
    empresa: {
      pessoa: {
        nomeReceita: {
          required,
        },
        nome: {
          required,
        },
        cnpj: {
          required,
        },
        email: {
          required,
          email,
        },
      },
      endereco: {
        cep: {
          required,
        },
        rua: {
          required,
        },
        bairro: {
          required,
        },
        estado: {
          required,
        },
        municipio: {
          required,
        },
      },
    },
  },
};
</script>
